import { Component, CUSTOM_ELEMENTS_SCHEMA, input, InputSignal } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { EditedPoint } from '../../../../interfaces/edit-route.interface';
import { FooterComponent, HeaderComponent, MainComponent } from './components';


@Component({
  selector: 'app-card',
  standalone: true,
  imports: [
    TranslateModule,
    HeaderComponent,
    MainComponent,
    FooterComponent
],
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CardComponent {
  public indexCard: InputSignal<number> = input.required<number>();
  public point = input<EditedPoint>();
  public isPointToDelete: InputSignal<boolean> = input(false);
  public isPointToAddNew: InputSignal<boolean> = input(false);
  public isPointToReplace: InputSignal<boolean> = input(false);
}
